import "@/index.css";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Intelligence from "@/pages/Intelligence";
import ArticlePage from "@/pages/ArticlePage";
import About from "@/pages/About";
import SpeakingPage from "@/pages/SpeakingPage";
import ContactPage from "@/pages/ContactPage";
import PlaceholderPage from "@/pages/PlaceholderPage";
import { AuthProvider } from "@/context/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSignals from "@/pages/admin/AdminSignals";
import AdminArticles from "@/pages/admin/AdminArticles";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import AdminSources from "@/pages/admin/AdminSources";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminAutomation from "@/pages/admin/AdminAutomation";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminVoice from "@/pages/admin/AdminVoice";
import MediaPage from "@/pages/MediaPage";
import OneSheet from "@/pages/OneSheet";
import PulsePage from "@/pages/PulsePage";
import ResearchPage from "@/pages/ResearchPage";
import AdminReports from "@/pages/admin/AdminReports";
import AdminPulse from "@/pages/admin/AdminPulse";

const PublicLayout = () => (
  <>
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

const AdminRoot = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[var(--bg-primary)]">
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/intelligence" element={<Intelligence />} />
            <Route path="/intelligence/:slug" element={<ArticlePage />} />
            <Route path="/research" element={<ResearchPage />} />
            <Route path="/adaptive-intelligence" element={<PlaceholderPage title="Adaptive Intelligence" subtitle="A signature framework for navigating an AI-shaped world — coming soon." />} />
            <Route path="/speaking" element={<SpeakingPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/pulse" element={<PulsePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/boards" element={<PlaceholderPage title="Boards & Advisory" subtitle="Selective advisory and board opportunities — coming soon." />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
          <Route path="/media/one-sheet" element={<OneSheet />} />
          <Route path="/admin" element={<AdminRoot />}>
            <Route path="login" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="signals" element={<AdminSignals />} />
              <Route path="pulse" element={<AdminPulse />} />
              <Route path="reports" element={<AdminReports />} />
              <Route path="drafts" element={<AdminArticles key="drafts" filterStatus="drafts" />} />
              <Route path="articles" element={<AdminArticles key="all" />} />
              <Route path="articles/new" element={<ArticleEditor key="new" />} />
              <Route path="articles/:id/edit" element={<ArticleEditor />} />
              <Route path="calendar" element={<AdminArticles key="scheduled" filterStatus="scheduled" />} />
              <Route path="sources" element={<AdminSources />} />
              <Route path="newsletter" element={<AdminSubscribers />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="automation" element={<AdminAutomation />} />
              <Route path="media" element={<AdminMedia />} />
              <Route path="voice" element={<AdminVoice />} />
            </Route>
          </Route>
        </Routes>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </Router>
  );
}

export default App;
